/* eslint-disable no-unused-vars */
import {
  useEffect 
} from "react";

// Add this type declaration at the top of the file
declare global {
  interface Window {
    __rum: {
      pid: string;
      endpoint: string;
    };
  }
}

const useAliyunRUM = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      // 设置 Aliyun RUM 配置
      window.__rum = {
        pid: "463m@f54c737d5d7183a",
        endpoint: "https://463m-default-cn.rum.aliyuncs.com",
      };

      // 创建并添加脚本元素
      const scriptEle = document.createElement("script");

      scriptEle.type = "text/javascript";
      scriptEle.async = true;
      scriptEle.src = "https://sdk.rum.aliyuncs.com/v2/browser-sdk.js";

      document.body.appendChild(scriptEle);
    }
  }, []);
};

export default useAliyunRUM;
